export default __webpack_public_path__ + "static/media/tech-advisor-advance.35e8cf94.png";